import styled from 'styled-components';
import {Check} from '@sparkware/app-utils';
import {MOBILE_CENTERED_HEADER} from "../../css-classes";

export interface DialogHeaderDefaultBoxProps {
    className?: string;
    height?: number;
}

export const DialogHeaderDefaultBox = styled.div<DialogHeaderDefaultBoxProps>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    background-color: ${props => props.theme.colors.backgroundLight};
    padding: 10px 15px;
    min-height: 30px;
    height: ${props => Check.isNullOrUndefined(props.height) ? 'auto' : props.height + 'px'};
    width: 100%;

    &.${MOBILE_CENTERED_HEADER} .dialog-header-title {
        text-align: center;
        margin: 0;
    }

    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
`;